<div class="main-container learnspace-theme">
  <div class="header responsive-container">
    <h1>Choose Your Program Template</h1>
    <mat-icon fontSet="fa" fontIcon="fa-close" class="large-close-icon" [mat-dialog-close]></mat-icon>
  </div>

  <div class="list responsive-container">
    <program-list-item *ngFor="let template of templates"
      [title]="template.title"
      [description]="template.description"
      [tags]="template.tags"
      [poster]="template.thumbnail"
      [experienceCount]="template.simulations"
      [clickDeactived]="true"
      [actionButtons]="getActionButtons(template)"
    ></program-list-item>
  </div>
</div>
